<template>
  <div class="bus-container">
    <div class="bus-shape">
      <div class="bus-front">
        <div class="bus-driver">{{ `traveller.driver` | translate }}</div>
        <div class="bus-front-row">
          <bus-place class="place" v-for="(place,i) in frontPlaces" :key="i" :label="place.label" :traveler="place.traveler" 
            @placed="seatTaken" @remove="seatEmptied" @nameClicked="nameClicked" />
        </div>
      </div>
      <div class="bus-rows">
        <div class="bus-left-col">
          <bus-place class="place" v-for="(place,i) in leftColumnPlaces" :key="i" :label="place.label" :traveler="place.traveler" 
          @placed="seatTaken" @remove="seatEmptied" @nameClicked="nameClicked" />
        </div>
        <div class="bus-right-col">
          <div class="bus-right-col-first">
            <bus-place class="place" v-for="(place,i) in rightColumnPlaces" :key="i" :label="place.label" :traveler="place.traveler" 
            @placed="seatTaken" @remove="seatEmptied" @nameClicked="nameClicked" />
          </div>
          <div class="bus-right-col-door" v-if="hasSecondDoor"> <div>ВРАТА</div></div>
          <div class="bus-right-col-last" v-if="hasSecondDoor">
            <bus-place class="place" v-for="(place,i) in rightColumnEndPlaces" :key="i" :label="place.label" :traveler="place.traveler" 
            @placed="seatTaken" @remove="seatEmptied" @nameClicked="nameClicked" />
          </div>
        </div>
      </div>
      <div class="bus-last-row">
        <bus-place class="place" v-for="(place,i) in lastRowPlaces" :key="i" :label="place.label" :traveler="place.traveler" 
        @placed="seatTaken" @remove="seatEmptied" @nameClicked="nameClicked" />
      </div>
    </div>
    
  </div>
</template>

<script>
import BusPlace from "./BusPlace.vue"

export default {
  name: "buscomponent",
  components: {
    BusPlace
  },
  props: {
    busId: {
      type: String,
      required: true
    },
    busType: {
      type: String,
      required: true
    },
    busRows: {
      type:Number
    },    
    travelers: {
      type: Array,
      required: false
    }
  },
  data() {

    let defaultBusType = '2doors'
    defaultBusType = '1door'

    if(this.busType !== undefined) {
      defaultBusType = this.busType
    }
    
    let rows = 6
    if(this.busRows !== undefined) {
      rows = this.busRows
    }

    let leftColumn = []
    let rightColumn = []
    let rightColumnSecond = []
    let lastRow = []
    let hasSecondDoor = false
    let frontRow = []
    let hasFrontRow = false

    let places = {}
    for (let index = 0; index < this.travelers.length; index++) {
      const traveler = this.travelers[index]
      if(traveler.busId === this.busId) {
        places[traveler.place] = traveler
      }
    }

    switch (defaultBusType) {
      case '2doors':
        leftColumn = Array.from({ length: 24 }, (v, k) => k + 1)
        for (let index = 0; index < 6; index++) {
          leftColumn[index * 2] = {label:index * 4 + 1}
          leftColumn[index * 2 + 1] = {label:index * 4 + 2}
        }
        for (let index = 6; index < 7; index++) {
          leftColumn[index * 2] = {label:index * 4 + 1 - 2}
          leftColumn[index * 2 + 1] = {label:index * 4 + 2 - 2}
        }

        for (let index = 7; index < 12; index++) {
          leftColumn[index * 2] = {label:index * 4 + 1 - 4}
          leftColumn[index * 2 + 1] = {label:index * 4 + 2 - 4}
        }

        leftColumn = this.addTravelersTo(leftColumn, places)

        rightColumn = Array.from({ length: 10 }, (v, k) => k + 1)

        for (let index = 0; index < 5; index++) {
          rightColumn[index * 2] = {label:index * 4 + 3}
          rightColumn[index * 2 + 1] = {label:index * 4 + 4}
        }

        //extra step
        rightColumn = this.addTravelersTo(rightColumn, places)

        rightColumnSecond = Array.from({ length: 10 }, (v, k) => k + 1)

        for (let index = 0; index < 5; index++) {
          rightColumnSecond[index * 2] = {label:index * 4 + 3 + 24}
          rightColumnSecond[index * 2 + 1] = {label:index * 4 + 4 + 24}
        }

        rightColumnSecond = this.addTravelersTo(rightColumnSecond, places)

        
        lastRow = Array.from({ length: 5 }, (v, k) => k + 1)

        for (let index = 0; index < 5; index++) {
          lastRow[index] = {label:44 + index + 1}
        }

        lastRow = this.addTravelersTo(lastRow, places)

        hasSecondDoor = true
        break;

      case '2doors-54seats':
        
        leftColumn = Array.from({ length: 24 }, (v, k) => k + 1)
        for (let index = 0; index < 6; index++) {
          leftColumn[index * 2] = {label:index * 4 + 1}
          leftColumn[index * 2 + 1] = {label:index * 4 + 2}
        }
        for (let index = 6; index < 7; index++) {
          leftColumn[index * 2] = {label:index * 4 + 1 - 2}
          leftColumn[index * 2 + 1] = {label:index * 4 + 2 - 2}
        }

        for (let index = 7; index < 13; index++) {
          leftColumn[index * 2] = {label:index * 4 + 1 - 4}
          leftColumn[index * 2 + 1] = {label:index * 4 + 2 - 4}
        }

        leftColumn = this.addTravelersTo(leftColumn, places)

        rightColumn = Array.from({ length: 10 }, (v, k) => k + 1)

        for (let index = 0; index < 5; index++) {
          rightColumn[index * 2] = {label:index * 4 + 3}
          rightColumn[index * 2 + 1] = {label:index * 4 + 4}
        }

        //extra step
        rightColumn = this.addTravelersTo(rightColumn, places)

        rightColumnSecond = Array.from({ length: 10 }, (v, k) => k + 1)

        for (let index = 0; index < 6; index++) {
          rightColumnSecond[index * 2] = {label:index * 4 + 3 + 24}
          rightColumnSecond[index * 2 + 1] = {label:index * 4 + 4 + 24}
        }

        rightColumnSecond = this.addTravelersTo(rightColumnSecond, places)

        
        lastRow = Array.from({ length: 5 }, (v, k) => k + 1)

        for (let index = 0; index < 5; index++) {
          lastRow[index] = {label:48 + index + 1}
        }
        //5 - number of seats on the last row
        frontRow = [{label:48 + 5 + 1}]

        lastRow = this.addTravelersTo(lastRow, places)

        frontRow = this.addTravelersTo(frontRow, places)
        hasFrontRow = true
        hasSecondDoor = true
        break;

      case '1door':
        leftColumn = Array.from({ length: rows * 2 }, (v, k) => k + 1)
        for (let index = 0; index < rows; index++) {
          leftColumn[index * 2] = {label:index * 4 + 1}
          leftColumn[index * 2 + 1] = {label:index * 4 + 2}
        }
        leftColumn = this.addTravelersTo(leftColumn, places)

        rightColumn = Array.from({ length: rows * 2 }, (v, k) => k + 1)

        for (let index = 0; index < rows; index++) {
          rightColumn[index * 2] = {label:index * 4 + 3}
          rightColumn[index * 2 + 1] = {label:index * 4 + 4}
        }
        rightColumn = this.addTravelersTo(rightColumn, places)

        lastRow = Array.from({ length: 5 }, (v, k) => k + 1)

        for (let index = 0; index < 5; index++) {
          lastRow[index] = {label:rows * 4 + index + 1}
        }
        lastRow = this.addTravelersTo(lastRow, places)
        break;
    
      default:
        break;
    }
    
    

    return {
      hasSecondDoor: hasSecondDoor,
      hasFrontRow: hasFrontRow,
      leftColumnPlaces: leftColumn,
      rightColumnPlaces: rightColumn,
      rightColumnEndPlaces: rightColumnSecond,
      frontPlaces: frontRow,
      lastRowPlaces: lastRow,
      assignedPlace: places
    };
  },
  mounted: function () {
    //nothing yet 
  },
  methods: {
      seatTaken (data) {
        data.bus = this.busId
        this.$emit("seatTaken", data)

      },
      seatEmptied (data) {
        data.bus = this.busId
        this.$emit("seatEmptied", data)
      },
      getTraveler (place) {
        
        let traveler = this.assignedPlace[place]
        if(traveler !== undefined && traveler != null) {
          return traveler
        }
        return null
      },
      nameClicked(data) {
        this.$emit("placeClicked", data)
      },
      addTravelersTo(listOfPlaces, travelersMap) {
        let result = []
        if(listOfPlaces)  {
          listOfPlaces.forEach(placeObject => {
            let label = placeObject.label
            let traveler = travelersMap[label] 
            if(traveler) {
              result.push({label, traveler})
            } else {
              result.push(placeObject)
            }
          });
        }
        return result
      }
  },
  computed: {
  },
  watch: {
    travelers : function (val, oldVal) {
      let places = {}
      for (let index = 0; index < val.length; index++) {
        const traveler = val[index]
        if(traveler.busId === this.busId) {
          places[traveler.place] = traveler
        }
      }
      this.assignedPlace = places

      this.leftColumnPlaces = this.addTravelersTo(this.leftColumnPlaces, places)
      this.rightColumnPlaces = this.addTravelersTo(this.rightColumnPlaces, places)
      this.lastRowPlaces = this.addTravelersTo(this.lastRowPlaces, places)
      
      if(this.hasSecondDoor) {
        this.rightColumnEndPlaces = this.addTravelersTo(this.rightColumnEndPlaces, places)
      }

      if(this.hasFrontRow) {
        this.frontPlaces = this.addTravelersTo(this.frontPlaces, places)
      }
      this.$forceUpdate()
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$color: red;
$busBackground: #ffffff;
$busBorderColor: #4ae387;

$busWidth: 570px;
$busHeight: 900px;
$busColumnWidth: 215px;
$bottomPadding: 5px;
$busPlaceWidht: 100px;
$busPlaceHeight: 90px;
$busPlaceBorderRadius: 30px;
$busPlaceBorderColor: #4ae387;
$busDriverHeight: $busPlaceHeight + 2 * $bottomPadding;
$busSecondDoorHeight: 2 * $busPlaceHeight + 4* $bottomPadding;


.bus-container {
  background-color: $busBackground;
}

.bus-shape {
  width: $busWidth;
  border: 2px solid $busBorderColor;
  display: block;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
}

.bus-front {
  width: $busWidth;
  height: $busDriverHeight;
  border: 1px solid $busBorderColor;
  display: flex;
  align-items: center;  
  justify-content: space-between;
}

.bus-driver {
    width: $busColumnWidth;
}

.bus-rows {
  width: $busWidth;
  border: 1px solid $busBorderColor;
  display: flex;  
  justify-content: space-between;
  // padding-bottom: $bottomPadding;
}

.bus-last-row {
  width: $busWidth;
  border: 1px solid $busBorderColor;
  display: flex;
  justify-content: space-between;
  // padding-left: 5px;
  // padding-right: 5px;
  // padding-bottom: $bottomPadding; 
}

.bus-left-col {
  width: $busColumnWidth;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: $bottomPadding;
  margin-left: 5px;
}

.bus-right-col {
  width: $busColumnWidth;
  height: 100%;
  display: flex;
  flex-direction: column;
  // margin-bottom: $bottomPadding;
  margin-right: 5px;
}

.bus-right-col-first {
  width: $busColumnWidth; 
  display: flex;

  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: $bottomPadding;
}

.bus-right-col-door {
  width: $busColumnWidth;
  height: $busSecondDoorHeight;
  display: flex;
  justify-content: center;
  align-items: center;

}

.bus-right-col-last {
  width: $busColumnWidth;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: $bottomPadding;
}
.bus-front-row {
  width: $busColumnWidth;
  display: flex;
  justify-content: center;
  align-items: center;
}

.place {
  margin-top: 5px;
  margin-bottom: 5px;
  width: $busPlaceWidht;
  height: $busPlaceHeight;
  border-radius: $busPlaceBorderRadius;
  border: 2px solid $busPlaceBorderColor;
  background-color: #ffffff;
  display: block;
  // justify-content: center;
  text-align: center;
}

</style>
